import React, { Component } from 'react';
import { Icon, List, Segment, Label, Form, Radio, Message, Input, TextArea, Button } from 'semantic-ui-react';

class MutualCompanies extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mutualCompanies: [],
        }
    }

    componentDidMount() {
        this.getMutualCompanies();
    }

    componentDidUpdate() {
        if (this.props.needsToUpdateMutualCompanies) {
            this.getMutualCompanies();
        }
    }

    getMutualCompanies = () => {
        fetch(`api/Application/GetMutualCompanies?coverageId=${this.props.coverageId}&retrieveExcluded=false`)
            .then((response) => response.json())
            .then(data => {
                this.props.changeNeedsToUpdateMutualCompanies();
                if (data.length === 0 && this.props.step < 5) {
                    this.props.goToNextStep();
                } else {
                    this.setState({ mutualCompanies: data });
                }
            });
    }

    render() {
        const { mutualCompanies } = this.state;
        const { applicationId, mutualCompanyAffiliated, mutualCompanyExplanation, fileName, readOnly, ownershipOverridden, saving } = this.props;
        const invalidExplanation = mutualCompanyExplanation === '';
        let ownershipLabel = 'Provide Explanation.', ownershipColor = 'red', ownershipIcon = 'hand paper';

        if (fileName !== '') {
            ownershipLabel = 'ERM-14 has been uploaded. You can change or view the form below.';
            ownershipColor = 'orange';
            ownershipIcon = 'exclamation triangle';
        }

        if (mutualCompanies.length === 0) {
            return null;
        }

        return (
            <div>
            <Segment>
                <Label
                    color='orange'
                    icon='exclamation triangle'
                    ribbon
                    content='Is the following a complete and accurate list of all mutual companies?'
                />
                <Form.Field>
                    <Radio
                        label='Yes, the list of companies is complete and accurate'
                        name='mutualCompanyAffiliatedRadioGroup'
                        value='Y'
                        checked={mutualCompanyAffiliated === 'Y'}
                        onChange={this.props.setMutualCompanyAffiliated}
                        disabled={readOnly}
                    />
                </Form.Field>
                <Form.Field>
                    <Radio
                        label='No, the list of companies is either incomplete and/or not accurate'
                        name='mutualCompanyAffiliatedRadioGroup'
                        value='N'
                        checked={mutualCompanyAffiliated === 'N'}
                        onChange={this.props.setMutualCompanyAffiliated}
                        disabled={readOnly}
                    />
                </Form.Field>
                <List divided verticalAlign='middle' className='mutual-company-list'>
                    {mutualCompanies.map(company => (
                        <List.Item key={company.coverageId}>{`${company.coverageId} - ${company.insuredName}`}</List.Item>
                    ))}
                </List>

            </Segment>
            {mutualCompanyAffiliated === 'Y' && (
                <Message info icon='bullhorn' content='This application must include data for all companies.' />
            )}
            {(mutualCompanyAffiliated === 'N' && !ownershipOverridden) && (
                <Segment>
                    <Label color={ownershipColor} icon={ownershipIcon} content={ownershipLabel} ribbon />
                    <Form as='div'>
                        <Form.Field required error={invalidExplanation}>
                            <label>Explanation</label>
                            <TextArea
                                autoHeight
                                placeholder='Enter your explanation here'
                                rows={3}
                                value={mutualCompanyExplanation}
                                onChange={this.props.onMutualCompanyExplanationChange}
                                disabled={readOnly}
                            />
                        </Form.Field>
                    </Form>
                    {(fileName !== '') && (
                        <Button as='div' labelPosition='left' className='file-download'>
                            <Label basic onClick={() => this.props.downloadAttachment(applicationId, 'ownership', fileName)} target='_blank'>
                                {fileName}
                            </Label>
                            <Button icon onClick={() => this.props.downloadAttachment(applicationId, 'ownership', fileName)} target='_blank'>
                                <Icon name='download' />
                            </Button>
                        </Button>
                    )}
                        <Form.Field>
                            <label>Please submit a copy of the NJCRIB ERM-14 Form or other documentation confirming appropriate ownership via the Manage Ownership Platform at <a href="https://www.njcrib.com/">www.njcrib.com</a>, Online Services.</label>
                    </Form.Field>
                    <Button
                        content='Submit for Review'
                        color='green'
                        style={{marginTop: '10px'}}
                        onClick={this.props.submitMutualCompanyApplication}
                        disabled={readOnly || saving}
                        loading={saving}
                    />
                </Segment>
            )}
            </div>
        );
    }

}

export default MutualCompanies;